export interface Environment {
  baseUrls: {
    entityApiUrl: string;
    claimApiUrl: string;
    medicalApiUrl: string;
    accessApiUrl: string;
    ediApiUrl: string;
    vocRehabApiUrl: string;
    complianceApiUrl: string;
    refApiUrl: string;
    userApiUrl: string;
    filingApiUrl: string;
    workflowApiUrl: string;
    documentApiUrl: string;
    noteApiUrl: string;
    notificationApiUrl: string;
    jobManagementUrl: string;
  };
  appInsightsKey: string;
  appInsightsEndpointUrl?: string;
  oAuthBaseAddress: string;
  oAuthClientId: string;
  appType: string;
  onBoardVersion: string;

  uploadContainerName: string;
  uploadUrl: string;
  convertContainerName: string;
  wcbPdfConversionUrl: string;
  wcbTechSupportUrl: string;
  wcbEmailAddress: string;

  idleTimeMins: number;
  idleCountdownMins: number;
  refreshValidAfterTokenMins: number;

  signalRShowNonErrorMessages: boolean;

  featureFlags: {
    onBoardLimitedRelease: boolean;
    allowEditReferenceData: boolean;
    cms1500ActivationDate: string;
    parDmeEnabled: boolean;
    parMtgEnabled: boolean;
  };
}

export enum ApplicationType {
  internal = 'internal',
  external = 'external',
}
